import "UI/Renderer/Base";

/** @namespace UI.Renderer */
NS("UI.Renderer");

/**
 * @class
 * @extends UI.Renderer.Base
 * todo compiled templates caching?
 */
UI.Renderer.EJS = new Static(UI.Renderer.Base, /** @lends UI.Renderer.EJS */ {
    init() { },

    render(name, args = {}) {
        try {
            return require('../../../templates/' + name + '.ejs')(args);
        } catch (e) {
            console.error(`UI.Renderer.EJS.render(${name})`, args);
            throw e;
        }
    }
});
